import Serial from "serial";

class GasSensor {
	constructor() {
	}
	initialize(device) {
		return( new Promise(function(resolve, reject) {
			var serial = new Serial();

			serial.onerror = function(event) {
				reject(event.message);
			}.bind(this);

			serial.onsuccess = function(event) {
				serial.onsuccess = function(event) {
					resolve(true);
				}.bind(this);
				serial.flush();
			}.bind(this);

			serial.open(device, {
				baudrate: 9600,
				databits: 8,
				parity: "none",
				stopbits: 1
			});

			this.__serial = serial;
		}.bind(this)) );
	}
	command(cmd) {
		return( new Promise(function(resolve, reject) {
			var message = "";
			this.__serial.onmessage = function(event) {
				var uint8Array = new Uint8Array(event.data);
        			var str = new TextDecoder("utf-8").decode( uint8Array );
		                message += str;
        			if (message.endsWith("\r\n")) {
            				 message = message.replace("\r\n", "");
					message = message.replace(" ", "");
					message = message.replace(cmd, "");
            				 resolve(message);
        			}
			}.bind(this)
			this.__serial.send(cmd+"\r\n");
		}.bind(this)) );
	}
}

export default GasSensor;